<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'brand' | 'inverse'
    size?: 'sm' | 'md'
    dot?: boolean
  }>(),
  { variant: 'neutral', size: 'md' },
)
</script>

<template>
  <span class="k-badge" :class="[`k-badge--${variant}`, `k-badge--${size}`]">
    <span v-if="dot" class="k-badge__dot" aria-hidden="true" />
    <slot />
  </span>
</template>

<style scoped>
.k-badge {
  display: inline-flex; align-items: center; gap: var(--k-space-1);
  border-radius: var(--k-radius-sm);
  font-weight: var(--k-font-weight-medium); white-space: nowrap;
}
.k-badge--sm { padding: 2px var(--k-space-2); font-size: var(--k-font-size-xs); line-height: var(--k-line-height-xs); }
.k-badge--md { padding: var(--k-space-1) var(--k-space-2); font-size: var(--k-font-size-sm); line-height: var(--k-line-height-md); }
.k-badge__dot { width: 6px; height: 6px; border-radius: var(--k-radius-circle); background: currentColor; flex: none; }

.k-badge--neutral { background: var(--k-color-bg-alt); color: var(--k-color-text-body); }
.k-badge--success { background: var(--k-color-success-tint); color: var(--k-color-success); }
.k-badge--warning { background: var(--k-color-warning-tint); color: var(--k-color-warning); }
.k-badge--danger { background: var(--k-color-danger-tint); color: var(--k-color-danger); }
.k-badge--info { background: var(--k-color-info-tint); color: var(--k-color-info); }
.k-badge--brand { background: var(--k-color-primary-tint); color: var(--k-color-primary-active); }
.k-badge--inverse { background: var(--k-color-bg-inverse); color: var(--k-color-text-inverse); }
</style>
